module.exports = __webpack_public_path__ + "fonts/invoice_icon.svg";